// extracted by mini-css-extract-plugin
export default {"Box":"base-cell-module__Box--ZP0qi","Box_1":"base-cell-module__Box_1--x3XMx"};